export const demodata = [
  {
    id: 1,
    audio: "./assets/Jordan-Critz-Meris.mp3",
    name: "Miki Matsubara",
    title: "Stay With Me ♪",
    img: "https://ih1.redbubble.net/image.4546560346.4850/flat,750x,075,f-pad,750x1000,f8f8f8.jpg",
    inPlaylist: false,
  },
  {
    id: 2,
    audio: "./assets/drift.mp3",
    name: "Toshiki Kadomatsu",
    title: "Airport Lady ♪",
    img: "https://lastfm.freetls.fastly.net/i/u/ar0/9be507b7ef351b0548d3f58da6a09a10.jpg",
    inPlaylist: false,
  },
  {
    id: 3,
    audio: "./assets/Jordan-Critz-Meris.mp3",
    name: "Omega Tribe",
    title: "Dear Breeze ♪",
    img: "https://i.scdn.co/image/ab6761610000e5ebdcac637d506908e16063a418",
    inPlaylist: false,
  },
  {
    id: 4,
    audio: "./assets/drift.mp3",
    name: "Yuri Tanaka",
    title: "City Lights ♪",
    img: "https://www.onthecornermanila.com/wp-content/uploads/2022/11/Yuri-Tanaka-City-Lights-3rd-Season-LP.jpg",
    inPlaylist: false,
  },
  {
    id: 5,
    audio: "./assets/Jordan-Critz-Meris.mp3",
    name: "Mariya Takeuchi ",
    title: "Plastic Love ♪",
    img: "https://i.scdn.co/image/ab67616d0000b273676ca4dc8c635709448286ef",
    inPlaylist: false,
  },
  {
    id: 6,
    audio: "./assets/drift.mp3",
    name: "Miki Matsubara",
    title: "Nr6 ♪",
    img: "https://i.scdn.co/image/ab6761610000e5ebdcac637d506908e16063a418",
  },
  {
    id: 7,
    audio: "./assets/Jordan-Critz-Meris.mp3",
    name: "Miki Matsubara",
    title: "Nr7 ♪",
    img: "https://lastfm.freetls.fastly.net/i/u/ar0/9be507b7ef351b0548d3f58da6a09a10.jpg",
    inPlaylist: false,
  },
  {
    id: 8,
    audio: "./assets/drift.mp3",
    name: "Miki Matsubara",
    title: "Nr8 ♪",
    img: "https://www.onthecornermanila.com/wp-content/uploads/2022/11/Yuri-Tanaka-City-Lights-3rd-Season-LP.jpg",
    inPlaylist: false,
  },
  {
    id: 9,
    audio: "./assets/Jordan-Critz-Meris.mp3",
    name: "Mariya Takeuchi ",
    title: "Nr9 ♪",
    img: "https://i.scdn.co/image/ab67616d0000b273676ca4dc8c635709448286ef",
    inPlaylist: false,
  },
  {
    id: 10,
    audio: "./assets/drift.mp3",
    name: "Miki Matsubara",
    title: "Nr10 ♪",
    img: "https://ih1.redbubble.net/image.4546560346.4850/flat,750x,075,f-pad,750x1000,f8f8f8.jpg",
    inPlaylist: false,
  },
  {
    id: 11,
    audio: "./assets/Jordan-Critz-Meris.mp3",
    name: "Miki Matsubara",
    title: "Nr11 ♪",
    img: "https://i.scdn.co/image/ab67616d0000b273676ca4dc8c635709448286ef",
    inPlaylist: false,
  },
];
